<div *ngIf="control" class="p-float-label my-4" >
  <!--    'p-disabled': control?.disabled || disabled,-->
  <!--  El ngStyle es necesario para el evento resize no vale con ponerlo en la clase -->

  <div class="d-flex flex-row full-width align-items-center" style="gap: 10px">
    <span class="p-float-label" style="flex: auto" [ngClass]="{ readonly: readonly }" [ngStyle]="{ 'max-height': '200px', 'overflow-y': control?.value ? 'auto' : 'hidden' }">
      <textarea
        pInputTextarea
        id="{{ componentId }}"
        class="full-width"
        [ngClass]="{ 'p-filled': control?.value !== null && control?.value !== undefined }"
        [ngStyle]="{ 'padding-top': '1.5rem' }"
        [rows]="rows"
        [cols]="30"
        [formControl]="control"
        [autoResize]="autoResize"
        ng-trim="true"
        [readonly]="readonly"
      ></textarea>
      <label *ngIf="label" for="{{ componentId }}" [ngClass]="{ primary: control?.value || control?.value === 0 }" for="float-input">{{ label | translate }}</label>
    </span>
    <i *ngIf="!!tooltip" class="pi pi-info-circle" [escape]="true" [pTooltip]="tooltip" tooltipPosition="top"></i>
  </div>
  <ui-form-validation-messages *ngIf="control?.errors" [control]="control"></ui-form-validation-messages>
</div>
